import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** Shell for every /organization/messages/* page. */
@Component({
  selector: 'messages-view',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './message-view.html',
})
export class MessageView {}
